import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { PublicComponentsModule } from '../public/public-components/public-components.module';
import { SecureComponentsModule } from '../secure/secure-components/secure-components.module';
import { ToggleSwitchComponent } from '../shared-module/components/toggle-switch/toggle-switch.component';
import { ToastrComponent } from '../shared-module/components/toastr/toastr.component';
import { ToastrHolderComponent } from '../shared-module/components/toastr-holder/toastr-holder.component';
import { SimpleToggleComponent } from '../shared-module/components/simple-toggle/simple-toggle.component';
import { providePrimeNG } from 'primeng/config';
import { CareAuditsPrimePreset } from './careaudits-prime.preset';
import { environment } from '../../environments/environment';
import { CustomerTerminologyInterceptor } from '../core-module/interceptors/customer-terminology.interceptor';


@NgModule({ declarations: [
        AppComponent,
        ToastrComponent,
        ToastrHolderComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        PublicComponentsModule,
        SecureComponentsModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: CustomerTerminologyInterceptor, multi: true },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideAnimations(),
        providePrimeNG({
            license: environment.primeUiLicense,
            theme: {
                preset: CareAuditsPrimePreset,
                options: {
                    darkModeSelector: 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'tailwind-base, primeng, tailwind-utilities'
                    }
                }
            }
        })
    ]
})
export class AppModule { }
